module.exports = __webpack_public_path__ + "static/media/succes-icon.271ffdb1.svg";